define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		_postView: function() {
			// summary: 
			var	v = this.viewParent.getChildView("SOProperties");
			if (v) {
				this.connect(v, "postAction", "_postActionProperties");
			}
			
			this.inherited(arguments);
		},

		_postActionProperties: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: notify view of change to attribute
			this.cacheView.cacheResponse(ac.m_response);
			this.refreshDataRows();
		}
	});
});